import React from 'react'
import {GithubContext} from '../Context/Context'
import {ExampleChart,Pie3D,Column3D,Bar3D,Doughnut2D} from './Charts' 
const Repos=()=>{

    const {repos} = React.useContext(GithubContext)
    
    const languages=repos.reduce((total,item)=>{
        
        const {language,stargazers_count} = item;
        if(!language) return total
        if(!total[language]){
            total[language]={label:language,value:1,stars:stargazers_count}
        }else{
            total[language] = {
                ...total[language],
                value:total[language].value+1,
                stars:total[language].stars + stargazers_count}
        }
        return total;
        
    },{})
const mostUsed = Object.values(languages).sort((a,b)=>{
    return b.value - a.value
}).slice(0,5)

//most stars per language
const mostPopular = Object.values(languages).sort((a,b)=>{
    return b.stars - a.stars
}).map((item)=>{
    return {...item, value:item.stars}
}).slice(0,5)

//stars , forks

let {stars,forks} = repos.reduce((total,item)=>{
    const {stargazers_count,name,forks} = item;
    total.stars[stargazers_count] = {label:name,value:stargazers_count}
    total.forks[forks]={label:name,value:forks}
    return total
},{
    stars:{},forks:{}
})

stars=Object.values(stars).slice(-5).reverse();
forks=Object.values(forks).slice(-5).reverse();

    return(
        <div className="container p-2">
            <div className="row">
                <div className="col-lg-6 p-1">
                    <Pie3D data={mostUsed}/>
                </div>
                <div className="col-lg-6 p-1">
                    <Doughnut2D data={mostPopular}/>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 p-1">
                    <Column3D data={stars}/>
                </div>
                <div className="col-lg-6 p-1">
                    <Bar3D data={forks}/>
                </div>
            </div>
        </div>
    )
}
export default Repos